import React from 'react';
import { CalendarDaysIcon, ClockIcon, InfoIcon, MapPinIcon } from 'lucide-react';
import { NewTabHint } from '../ui/NewTabHint';
import type { BcmEvent } from '../../data/events';
const categoryStyles: Record<BcmEvent['category'], string> = {
  'Fall 2026': 'bg-brand-yellow text-[#3d2b00]',
  Weekly: 'bg-brand-blue text-brand-navy',
  'Coming Soon': 'bg-brand-pink text-[#3f1730]'
};
export function EventCard({
  event
}: {
  event: BcmEvent;
}) {
  return <article className="flex h-full flex-col rounded-[20px] border-2 border-brand-navy bg-white p-6 transition-transform duration-200 hover:-translate-y-1" data-id="element-77" data-mp="1ieb23r0hzv87">
      <span className={`inline-flex w-fit items-center rounded-full px-3 py-1 font-meta text-[11px] font-semibold uppercase tracking-[0.14em] ${categoryStyles[event.category]}`} data-id="element-78" data-mp="18ngccco1mdi0">
        {event.category}
      </span>

      <h3 className="mt-4 font-display text-2xl font-bold leading-tight text-brand-navy" data-id="element-79" data-mp="znl167uhmihz">
        {event.title}
      </h3>

      <dl className="mt-4 space-y-2 font-meta text-[13px] text-ink" data-id="element-80" data-mp="1cs6n4djfryy8">
        <div className="flex items-start gap-2" data-id="element-81" data-mp="1cqvjcdpzqr74">
          <dt className="sr-only" data-id="element-82" data-mp="1hkgkgemvs1aj">Date</dt>
          <CalendarDaysIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-navy" data-id="element-83" data-mp="1hl9kyxv8xuk8" />
          <dd data-id="element-84" data-mp="13q75pk4iesur">{event.date}</dd>
        </div>
        {event.time ? <div className="flex items-start gap-2" data-id="element-85" data-mp="18rmr5daln1do">
            <dt className="sr-only" data-id="element-86" data-mp="1wgz14fdr3dh1">Time</dt>
            <ClockIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-navy" data-id="element-87" data-mp="1wh7d8521uer6" />
            <dd data-id="element-88" data-mp="20gzlshrg0kwj">{event.time}</dd>
          </div> : null}
        {event.location ? <div className="flex items-start gap-2" data-id="element-89" data-mp="1mhq9vua9scyd">
            <dt className="sr-only" data-id="element-90" data-mp="1rhmbxnzepuba">Location</dt>
            <MapPinIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-navy" data-id="element-91" data-mp="1rgb7rn21ukjn" />
            <dd data-id="element-92" data-mp="b2l58kqkw4c4">{event.location}</dd>
          </div> : null}
        {event.locationNote ? <div className="flex items-start gap-2" data-id="element-93" data-mp="g38w96et4l6c">
            <dt className="sr-only" data-id="element-94" data-mp="3s5h8ibxjlaqv">Details</dt>
            <InfoIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-navy" data-id="element-95" data-mp="3s57gkisxstij" />
            <dd data-id="element-96" data-mp="3o5f3ptwig17d">{event.locationNote}</dd>
          </div> : null}
      </dl>

      <p className="mt-4 font-sans text-[15px] leading-relaxed text-ink" data-id="element-97" data-mp="3jcdm3e4x5nk3">{event.description}</p>

      {event.clarification ? <p className="mt-3 font-meta text-[12.5px] leading-relaxed text-ink" data-id="element-98" data-mp="3ee2bv2appb1c">
          {event.clarification}
        </p> : null}

      {event.cta || event.reference ? <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-3 pt-1" data-id="element-99" data-mp="34fd4i3gfz8zc">
          {event.cta ? <a href={event.cta.href} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] items-center rounded-full border-2 border-brand-navy bg-brand-navy px-5 font-display text-sm font-semibold text-white transition-colors hover:bg-[#083a7c]" data-id="element-100" data-mp="30f302v8asqml">
              {event.cta.label}
              <NewTabHint data-id="element-101" data-mp="118e35wnulrpk" />
            </a> : null}
          {event.reference ? <a href={event.reference.href} target="_blank" rel="noopener noreferrer" className="font-meta text-[13px] font-semibold text-brand-navy underline underline-offset-4 hover:no-underline" data-id="element-102" data-mp="165xi6ysde8ik">
              {event.reference.label}
              <NewTabHint data-id="element-103" data-mp="i9jriwjol7dm" />
            </a> : null}
        </div> : null}
    </article>;
}